/* GG cart integrity + mobile add-to-cart.

   TWO PARTS, DIFFERENT SCOPES.

   1. CART-PAGE RECONCILER — runs on every viewport (desktop AND mobile).
      Every device line that records a chosen warranty must have a warranty line
      paired to it, in the SAME QUANTITY. Neither is guaranteed by the theme: the
      cart page has no quantity sync of its own (cart-logic.js has one but is not
      loaded there), so changing a device's quantity in the cart leaves its
      warranty behind — 2 devices with 1 warranty, or 1 device still paying for 2.

   2. MOBILE ADD-TO-CART ORCHESTRATOR — mobile only, everything below the guard.
      On phones this file is the sole orchestrator; the theme's synchronous one is
      disabled in snippets/warranty-card-styles.liquid because it froze the page.
      Flow: overlay -> let theme+apps add natively -> wait for the cart to stop
      changing -> re-add the device if it was dropped (adopting/minting an _io group
      so the warranty stays linked) -> add the warranty if this device is not
      covered -> go to /cart. Everything is checked before adding, so nothing can
      duplicate; repeat taps are ignored. */
(function () {
  var d = document, busy = false;

  // Diagnostics: OFF for customers. Append ?ggdebug=1 to any URL to turn it on for
  // that browsing session; a readout then appears on the cart page.
  var DEBUG = false, LOGKEY = '__gg_atc_log';
  try {
    if (/[?&]ggdebug=1/.test(location.search)) sessionStorage.setItem('__gg_debug', '1');
    DEBUG = sessionStorage.getItem('__gg_debug') === '1';
  } catch (_) {}
  function log(tag, data) {
    if (!DEBUG) return;
    try {
      var a = JSON.parse(sessionStorage.getItem(LOGKEY) || '[]');
      var e = { tag: tag };
      for (var k in data) { if (Object.prototype.hasOwnProperty.call(data, k)) e[k] = data[k]; }
      a.push(e);
      sessionStorage.setItem(LOGKEY, JSON.stringify(a.slice(-40)));
    } catch (_) {}
  }

  // PART 1 — all viewports.
  if (location.pathname.indexOf('/cart') === 0) reconcileCart();

  // ---- PART 2: everything below here is mobile-only. Desktop keeps the theme's
  // ---- own add-to-cart flow untouched.
  if (!(window.matchMedia && window.matchMedia('(max-width: 767px)').matches)) return;

  // Warranties already in the cart at page load. Used only as a fallback when a
  // device carries no _io group to match a warranty against.
  var warrantyBefore = 0;
  var warrantyBeforeReady = cartJson().then(function (c) { warrantyBefore = countWarranties(c); }, function () {});

  d.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest && e.target.closest('.product-form__add-button');
    if (!btn) return;
    var form = btn.form || (btn.closest && btn.closest('form.product-form'));
    if (!form) return;
    if (busy) { e.preventDefault(); e.stopImmediatePropagation(); return; } // ignore repeat taps
    var idEl = form.querySelector('[name="id"]');
    var qEl = form.querySelector('[name="quantity"]');
    var variantId = idEl ? String(idEl.value) : null;
    var qty = (qEl && parseInt(qEl.value, 10) > 0) ? parseInt(qEl.value, 10) : 1;
    if (!variantId) return;
    var warrantyPrice = readWarrantyPrice();   // captured at click time
    busy = true;
    showOverlay();
    log('click', { variant: variantId, priceRead: warrantyPrice, wBefore: warrantyBefore });
    // NOTE: the baseline is deliberately the PAGE-LOAD count (measured above).
    // Re-measuring at click time would race the warranty app: if its add lands
    // first, this tap's own warranty would be counted as "already there" and
    // skipped — which is exactly the failure we are fixing.
    // Let the native add + apps run (do NOT preventDefault the first tap).
    setTimeout(function () { settle(variantId, qty, warrantyPrice); }, 700);
  }, true);

  function readWarrantyPrice() {
    var cont = d.getElementById('infiniteoptions-container');
    var chk = d.querySelector('#infiniteoptions-container input[type="checkbox"]');
    var selected = (chk && chk.checked) || (cont && cont.classList.contains('wc-active'));
    if (!selected) return null;
    var sources = [];
    if (chk) sources.push(chk.value);
    var hp = d.querySelector('input[name="properties[Green Gadgets Warranty]"]');
    if (hp) sources.push(hp.value);
    if (cont) { var pe = cont.querySelector('.wc-price'); if (pe) sources.push(pe.textContent); }
    for (var i = 0; i < sources.length; i++) {
      var m = String(sources[i] || '').match(/\$\s*([\d.,]+)/);
      if (m) return m[1].replace(/,/g, '').replace(/\.0+$/, '');
    }
    return null;
  }

  function settle(variantId, qty, warrantyPrice) {
    var start = Date.now(), lastCount = -1, stableSince = Date.now();
    (function poll() {
      cartJson().then(function (cart) {
        if (cart.item_count !== lastCount) { lastCount = cart.item_count; stableSince = Date.now(); }
        var settled = (Date.now() - stableSince) > 1200;   // cart stopped changing
        var timedOut = (Date.now() - start) > 9000;
        if (settled || timedOut) ensureDevice(cart, variantId, qty, warrantyPrice);
        else setTimeout(poll, 400);
      }, function () { setTimeout(poll, 500); });
    })();
  }

  function ensureDevice(cart, variantId, qty, warrantyPrice) {
    var existing = null;
    (cart.items || []).forEach(function (i) { if (String(i.variant_id) === variantId) existing = i; });
    if (existing) {
      var g = existing.properties && existing.properties._io_order_group;
      // The device line carries the customer's choice as a visible property
      // ("Green Gadgets Warranty: 24 Months ($59)"). That is authoritative — it is
      // what the form actually submitted — so fall back to it when the click-time
      // DOM read came back empty, which happens if the warranty widget re-rendered
      // between the tap and the read. Without this the warranty is silently never
      // added: the cart shows the selection but nothing is charged for it.
      var wp = warrantyPrice || priceFromProps(existing.properties);
      log('device', { present: true, group: g || null, priceUsed: wp });
      ensureWarranty(qty, wp, g || null);
      return;
    }
    // Device was dropped — re-add it. Adopt the orphaned warranty's group when there is
    // one; otherwise mint a fresh group id, so that a warranty we add ourselves can still
    // be linked to this device. An unlinked warranty stays in the cart but is no longer
    // removed together with its device, which is what we must avoid.
    var group = findOrphanGroup(cart) || String(Date.now());
    var props = { _io_order_group: group };
    // Carry over the customer-visible warranty choice exactly as the form submits
    // it. Without this the re-added device no longer says it wants a warranty, so
    // the cart reconciler above can't tell it needs one — and a warranty lost later
    // would never be restored. We're still on the product page here, so the form's
    // hidden input is the authoritative source.
    var lbl = (d.querySelector('input[name="properties[Green Gadgets Warranty]"]') || {}).value;
    if (lbl) props['Green Gadgets Warranty'] = lbl;
    var body = { id: parseInt(variantId, 10), quantity: qty, properties: props };
    addJson(body).then(
      function () { ensureWarranty(qty, warrantyPrice, group); },
      function () { ensureWarranty(qty, warrantyPrice, group); }
    );
  }

  // Warranty price as recorded on a cart line by the form, e.g. "24 Months ($59)".
  function priceFromProps(props) {
    if (!props) return null;
    var v = props['Green Gadgets Warranty'];
    if (!v) return null;
    var m = String(v).match(/\$\s*([\d.,]+)/);
    return m ? m[1].replace(/,/g, '').replace(/\.0+$/, '') : null;
  }

  function findOrphanGroup(cart) {
    var parents = {};
    (cart.items || []).forEach(function (i) {
      var g = i.properties && i.properties._io_order_group;
      if (g !== undefined && g !== null) parents[g] = true;
    });
    var orphan = null;
    (cart.items || []).forEach(function (i) {
      var pg = i.properties && i.properties._io_parent_order_group;
      if (pg !== undefined && pg !== null && !parents[pg]) orphan = pg;
    });
    return orphan;
  }

  // Is THIS device already covered? Judged per device via the Infinite Options
  // link (warranty._io_parent_order_group === device._io_order_group), never by a
  // global warranty count: with several devices in one cart, a rising total says
  // nothing about whether *this* device got its warranty. That global count is
  // what let a 2nd device silently end up uncovered.
  function hasWarrantyFor(cart, group) {
    if (!group) return null;                   // no link available — cannot tell
    return (cart.items || []).some(function (i) {
      return i.properties && String(i.properties._io_parent_order_group) === String(group) &&
             (/Extended Warranty/i.test(i.title || '') || i.properties._io_field_name);
    });
  }

  function ensureWarranty(qty, warrantyPrice, group) {
    if (!warrantyPrice) { log('warranty', { decision: 'no-price' }); go(); return; }
    cartJson().then(function (cart) {
      var covered = hasWarrantyFor(cart, group);
      log('warranty', { covered: covered, price: warrantyPrice, group: group || null, total: countWarranties(cart), before: warrantyBefore });
      // Fall back to the count heuristic only when the device carries no group at
      // all, so there is nothing to match a warranty against.
      if (covered === null) covered = countWarranties(cart) > warrantyBefore;
      if (!covered) { addWarranty(qty, warrantyPrice, group); return; }
      // Covered — but the app can still roll its own line back a moment later.
      // Re-check once before leaving; a selected warranty must never be missing
      // when the customer reaches the cart.
      setTimeout(function () {
        cartJson().then(function (c2) {
          var still = hasWarrantyFor(c2, group);
          if (still === null) still = countWarranties(c2) > warrantyBefore;
          if (still) go(); else addWarranty(qty, warrantyPrice, group);
        }, go);
      }, 900);
    }, go);
  }

  function addWarranty(qty, warrantyPrice, group) {
    fetch('/products/' + warrantyPrice + '-green-gadgets-extended-warranty-24-months.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { if (!r.ok) throw 0; return r.json(); })
      .then(function (p) {
        var vid = p && p.variants && p.variants[0] && p.variants[0].id;
        if (!vid) { log('addWarranty', { error: 'no-variant' }); go(); return; }
        var props = { '_io_field_name': 'Green Gadgets Warranty' };
        // Link the warranty to its device so the cart page removes them together.
        if (group) props['_io_parent_order_group'] = group;
        addJson({ id: vid, quantity: qty, properties: props }).then(
          function (r) { log('addWarranty', { variant: vid, status: r && r.status }); go(); },
          function () { log('addWarranty', { status: 'network-error' }); go(); }
        );
      }, function () { log('addWarranty', { error: 'fetch-failed', price: warrantyPrice }); go(); });
  }

  function countWarranties(cart) {
    return (cart.items || []).filter(function (i) {
      return /Extended Warranty/i.test(i.title || '') || (i.properties && i.properties._io_field_name);
    }).reduce(function (s, i) { return s + (i.quantity || 1); }, 0);
  }
  function cartJson() { return fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); }); }
  function addJson(body) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    });
  }
  function go() { window.location.href = '/cart'; }

  // Debug readout on the cart page (only when ?ggdebug=1 armed the session).
  if (DEBUG && location.pathname.indexOf('/cart') === 0) {
    try {
      var entries = JSON.parse(sessionStorage.getItem(LOGKEY) || '[]');
      if (entries.length) {
        var box = d.createElement('details');
        box.style.cssText = 'position:fixed;left:8px;right:8px;bottom:8px;z-index:99998;background:#fff;border:1px solid #cfe0bf;border-radius:8px;padding:8px 10px;font:11px/1.35 monospace;color:#2f3a2a;box-shadow:0 2px 10px rgba(0,0,0,.15);max-height:45vh;overflow:auto';
        var sum = d.createElement('summary');
        sum.style.cssText = 'cursor:pointer;font-weight:700';
        sum.textContent = 'ATC diagnostic (' + entries.length + ') — tap to open';
        box.appendChild(sum);
        var pre = d.createElement('pre');
        pre.style.cssText = 'margin:6px 0 0;white-space:pre-wrap;word-break:break-all';
        pre.textContent = entries.map(function (e) {
          var parts = [];
          for (var k in e) { if (k !== 'tag' && Object.prototype.hasOwnProperty.call(e, k)) parts.push(k + '=' + e[k]); }
          return e.tag + ': ' + parts.join(' ');
        }).join('\n');
        box.appendChild(pre);
        if (d.body) d.body.appendChild(box);
        else d.addEventListener('DOMContentLoaded', function () { d.body.appendChild(box); });
      }
    } catch (_) {}
  }

  // --- Cart-page reconciler -------------------------------------------------
  // Last line of defence, and the important one: when the warranty app does not
  // intercept the form, the browser performs a native POST and LEAVES the product
  // page, so none of the recovery above ever runs. The device still lands in the
  // cart carrying "Green Gadgets Warranty: 24 Months ($X)" while nothing is
  // charged for it. Here we re-check on the cart page itself: every device line
  // that records a chosen warranty must have a warranty line paired to it.
  function isWarrantyLine(i) {
    return /Extended Warranty/i.test(i.title || '') || !!(i.properties && i.properties._io_field_name);
  }

  function reconcileCart() {
    var last = 0;
    try { last = parseInt(sessionStorage.getItem('__gg_recon') || '0', 10); } catch (_) {}
    if (Date.now() - last < 15000) return;              // never loop on reload
    cartJson().then(function (cart) {
      var items = cart.items || [];
      var warranties = [];
      items.forEach(function (i) { if (isWarrantyLine(i)) warranties.push(i); });
      var used = {}, missing = [], qtyFix = {}, qtyFixCount = 0;
      items.forEach(function (it) {
        if (isWarrantyLine(it)) return;
        var price = priceFromProps(it.properties);
        if (!price) return;                              // no warranty chosen here
        var g = it.properties && it.properties._io_order_group;
        var hit = -1;
        warranties.forEach(function (w, wi) {            // prefer the explicit link
          if (used[wi] || hit > -1 || !g) return;
          var wg = w.properties && w.properties._io_parent_order_group;
          if (String(wg) === String(g)) hit = wi;
        });
        warranties.forEach(function (w, wi) {            // else an unlinked one of the same price
          if (used[wi] || hit > -1) return;
          var wg = w.properties && w.properties._io_parent_order_group;
          if (!wg && new RegExp('\\$\\s*' + price + '(\\D|$)').test(w.title || '')) hit = wi;
        });
        if (hit > -1) {
          used[hit] = true;
          // The warranty covers ONE device each, so its quantity has to track the
          // device's. Changing quantity on the cart page does not do this, which
          // leaves either an uncovered device or a warranty the customer still pays
          // for. Fix it to match, in whichever direction it drifted.
          var w = warranties[hit];
          var want = it.quantity || 1;
          if ((w.quantity || 1) !== want) { qtyFix[w.key] = want; qtyFixCount++; }
        } else {
          missing.push({ price: price, group: g || null, qty: it.quantity || 1 });
        }
      });
      log('reconcile', { lines: items.length, warranties: warranties.length, missing: missing.length, qtyFixes: qtyFixCount });
      if (!missing.length && !qtyFixCount) return;
      try { sessionStorage.setItem('__gg_recon', String(Date.now())); } catch (_) {}
      var pending = missing.length + (qtyFixCount ? 1 : 0), done = 0;
      function step() { if (++done === pending) location.reload(); }
      if (qtyFixCount) {
        fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ updates: qtyFix })
        }).then(function (r) { log('reconcileQty', { fixes: qtyFixCount, status: r && r.status }); step(); },
                function () { log('reconcileQty', { status: 'error' }); step(); });
      }
      missing.forEach(function (m) { addWarrantyLine(m, step); });
    }, function () {});
  }

  function addWarrantyLine(m, done) {
    fetch('/products/' + m.price + '-green-gadgets-extended-warranty-24-months.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { if (!r.ok) throw 0; return r.json(); })
      .then(function (p) {
        var vid = p && p.variants && p.variants[0] && p.variants[0].id;
        if (!vid) { log('reconcileAdd', { error: 'no-variant', price: m.price }); done(); return; }
        var props = { '_io_field_name': 'Green Gadgets Warranty' };
        if (m.group) props['_io_parent_order_group'] = m.group;
        addJson({ id: vid, quantity: m.qty, properties: props }).then(
          function (r) { log('reconcileAdd', { price: m.price, status: r && r.status }); done(); },
          function () { log('reconcileAdd', { price: m.price, status: 'error' }); done(); }
        );
      }, function () { log('reconcileAdd', { error: 'fetch-failed', price: m.price }); done(); });
  }

  function showOverlay() {
    try {
      if (d.getElementById('gg-atc-overlay')) return;
      var o = d.createElement('div');
      o.id = 'gg-atc-overlay';
      o.setAttribute('role', 'status');
      o.style.cssText = 'position:fixed;inset:0;z-index:99999;display:flex;flex-direction:column;align-items:center;justify-content:center;gap:16px;background:rgba(255,255,255,.85);font-family:inherit;color:#2f3a2a;';
      o.innerHTML = '<div style="width:38px;height:38px;border:3px solid #cfe0bf;border-top-color:#5f8a2e;border-radius:50%;animation:ggspin .8s linear infinite"></div><div style="font-size:15px;font-weight:600">Adding to cart…</div><style>@keyframes ggspin{to{transform:rotate(360deg)}}</style>';
      d.body.appendChild(o);
    } catch (_) {}
  }
})();
